import axios from '@/http/api'
export const insertFeedback = data =>{
  return axios({
    url:'/IQProduceSystem/userInfoController/insertFeedback',
    method:'post',
    data
  })
}

export const selectUserFeedback = data =>{
  return axios({
    url:'/IQProduceSystem/userInfoController/selectFeedback',
    method:'post',
    data
  })
}

export const deltUserFeedback = data =>{
  return axios({
    url:'/IQProduceSystem/userInfoController/deletetFeedback',
    method:'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/feedBack.js